const LOCAL_STORAGE_TYPES = {
    restart: 'restart',
    isGettingStart: 'isGettingStart',
    autoRefreshTimeout: 'autoRefreshTimeout',
    dontShowConfirmForTranscription: 'transcriptionConfirm',
    currentAiAgent: 'currentAiAgent',
    diagnosticAiMessages: 'diagnosticAiMessages',
    diagnosticAiConversationId: 'diagnosticAiConversationId',
    builderAiMessages: 'builderAiMessages',
    builderAiConversationId: 'builderAiConversationId',
}

export {
    LOCAL_STORAGE_TYPES,
}
